import React from "react";
import { Card, Table, Tag, Tooltip } from "antd";
import {
  HistoryOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { format } from "date-fns";

const SendHistory = ({ history, loading, pagination, onPageChange }) => {
  const getStatusTag = (status) => {
    const statusConfig = {
      completed: { color: "success", icon: <CheckCircleOutlined />, label: "Completed" },
      failed: { color: "error", icon: <CloseCircleOutlined />, label: "Failed" },
      in_progress: { color: "processing", icon: <ClockCircleOutlined />, label: "In Progress" },
      pending: { color: "default", icon: <ClockCircleOutlined />, label: "Pending" },
    };
    const config = statusConfig[status] || statusConfig.pending;
    return (
      <Tag color={config.color} icon={config.icon}>
        {config.label}
      </Tag>
    );
  };

  const columns = [
    {
      title: "Run Date",
      dataIndex: "startedAt",
      key: "startedAt",
      width: 180,
      render: (date) => {
        if (!date) return "-";
        return (
          <Tooltip title={format(new Date(date), "PPpp")}>
            <span style={{ fontWeight: 500 }}>{format(new Date(date), "MMM dd, yyyy HH:mm")}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      width: 120,
      render: (_, record) => {
        // Derive status from stats
        const stats = record.stats || {};
        let status = "completed";
        if (stats.failed > 0 && stats.sent === 0) {
          status = "failed";
        } else if (stats.failed > 0) {
          status = "completed"; // partial success
        }
        if (!record.completedAt) {
          status = "in_progress";
        }
        return getStatusTag(status);
      },
    },
    {
      title: "Targeted",
      dataIndex: ["stats", "targeted"],
      key: "targeted",
      width: 100,
      align: "center",
      render: (val) => <span style={{ fontWeight: 500 }}>{val?.toLocaleString() || 0}</span>,
    },
    {
      title: "Sent",
      dataIndex: ["stats", "sent"],
      key: "sent",
      width: 100,
      align: "center",
      render: (val) => (
        <span style={{ color: "#52c41a", fontWeight: 500 }}>{val?.toLocaleString() || 0}</span>
      ),
    },
    {
      title: "Failed",
      dataIndex: ["stats", "failed"],
      key: "failed",
      width: 100,
      align: "center",
      render: (val) => (
        <span style={{ color: val > 0 ? "#f5222d" : "#999", fontWeight: 500 }}>
          {val?.toLocaleString() || 0}
        </span>
      ),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      width: 100,
      align: "center",
      render: (ms) => {
        if (!ms) return <span style={{ color: "#999" }}>-</span>;
        const seconds = Math.floor(ms / 1000);
        if (seconds < 60) return `${seconds}s`;
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}m ${remainingSeconds}s`;
      },
    },
    {
      title: "Completed",
      dataIndex: "completedAt",
      key: "completedAt",
      width: 120,
      align: "center",
      render: (date) => (date ? format(new Date(date), "HH:mm:ss") : <span style={{ color: "#999" }}>-</span>),
    },
  ];

  return (
    <Card
      title={
        <span>
          <HistoryOutlined style={{ marginRight: 8, color: "#fa8c16" }} />
          Send History
        </span>
      }
      bordered={false}
      style={{ marginBottom: 24 }}
    >
      <Table
        dataSource={history || []}
        columns={columns}
        loading={loading}
        rowKey="runId"
        pagination={{
          current: pagination?.current || 1,
          pageSize: pagination?.pageSize || 10,
          total: pagination?.total || 0,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} records`,
          onChange: onPageChange,
        }}
        size="middle"
      />
    </Card>
  );
};

export default SendHistory;
